import React, { useEffect, useState } from 'react';
import { JoyLogo } from '@apps/createWedding/components/JoyLogo';
import { useCreateWeddingTelemetry } from '@apps/createWedding/CreateWedding.telemetry';
import { ProgressBar } from '@apps/createWedding/components/ProgressBar';
import { useRandomizedABTest } from '@apps/createWedding/hooks/useRandomizedABTest';
import { useFeatureValue } from '@shared/core/featureFlags';
import { SpacingStack } from '@withjoy/joykit';
import { GuestBanner } from '@apps/createWedding/components/GuestBanner';
import { SocialProofBanner } from '@apps/createWedding/components/SocialProofBanner';
import { SupportedView, viewMap, ViewProvider } from './ViewProvider';

type ViewProps = Readonly<{
  defaultView?: SupportedView;
  isExperimentControl: boolean;
}>;

/**
 * It is just an abstraction over react-router, and in my opinion we should get rid of it,
 */
export const View: React.FC<ViewProps> = ({ defaultView = 'createAccount', isExperimentControl = true }) => {
  const [currentView, setCurrentView] = useState<SupportedView>(defaultView);
  const telemetry = useCreateWeddingTelemetry();
  const progressBarEnabled = useFeatureValue('enableCreateWeddingProgressBar');
  const showProgressBar = useRandomizedABTest('createWeddingProgressBar');

  useEffect(() => {
    telemetry[currentView]?.enter();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const changeView = (view: SupportedView) => {
    telemetry[view]?.enter();
    setCurrentView(view);
  };

  const Component = viewMap[currentView];

  return (
    <ViewProvider value={{ changeView, currentView }}>
      {isExperimentControl && <GuestBanner />}
      {!isExperimentControl && <SocialProofBanner />}
      <SpacingStack style={{ marginTop: !isExperimentControl && currentView === 'createAccount' ? '56px' : '64px' }} spacing={6} width="100%" alignItems="center">
        <JoyLogo />
        <SpacingStack spacing={8}>
          {progressBarEnabled && showProgressBar && <ProgressBar />}
          <Component />
        </SpacingStack>
      </SpacingStack>
    </ViewProvider>
  );
};
